import nginx from "refractor/nginx";
export default nginx;